import React from "react";
import StarHighlight from "../../StarHighlight";

import { Star, StarOutline } from "@material-ui/icons";

export default function StaffRating({ rating }) {
  return (
    <div className="staff-star-wrapper">
      <div className="star-wrapper">
        {[...Array(5)].map((star, index) => {
          index += 1;
          return (
            <span className="staff-star" key={index}>
              {index <= rating ? (
                <Star style={{ fill: "#ebbc18" }} />
              ) : (
                <StarOutline style={{ fill: "var(--text-color-2)" }} />
              )}
            </span>
          );
        })}
      </div>
      <p className="rating-text">{rating}</p>
    </div>
  );
}
